import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function LanguageGate() {
  const { setLang } = useLang();

  const options = [
    { code: "es", label: "Español" },
    { code: "en", label: "English" },
  ];

  return (
    <div
      data-testid="language-gate"
      className="fixed inset-0 z-[100] min-h-screen bg-navy text-offwhite flex items-center justify-center overflow-hidden px-4"
    >
      {/* Backdrop — now subtly visible behind the glass */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1699621106755-4fe40ce95d64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODA0NDY5NTZ8MA&ixlib=rb-4.1.0&q=85')",
        }}
      />
      {/* Soft navy vignette keeps text readable while letting the scene bleed through */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy/50 via-navy/40 to-navy/70" />
      <div className="absolute inset-0 gold-glow pointer-events-none" />

      {/* Liquid Glass panel */}
      <motion.div
        initial={{ opacity: 0, y: 18, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="liquid-glass relative w-full max-w-md mx-auto px-6 py-10 sm:px-12 sm:py-14 rounded-3xl sm:rounded-[28px] text-center"
      >
        {/* specular top edge highlight */}
        <div className="glass-sheen pointer-events-none absolute inset-x-10 top-0 h-px" />

        <div className="inline-flex items-center gap-3 mb-8 sm:mb-12">
          <span className="inline-flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center border border-gold/60 text-gold font-serif text-xl sm:text-2xl leading-none">
            M
          </span>
          <span className="font-serif text-3xl sm:text-4xl tracking-wide">
            Med<span className="text-gold">Prime</span>
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-4">
          {options.map((o) => (
            <button
              key={o.code}
              data-testid={`gate-lang-${o.code}`}
              onClick={() => setLang(o.code)}
              className="liquid-glass-btn group rounded-2xl p-6 flex items-center justify-between"
            >
              <span className="font-serif text-2xl sm:text-3xl text-offwhite group-hover:text-gold transition-colors">
                {o.label}
              </span>
              <ArrowRight
                size={18}
                className="text-gold opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
              />
            </button>
          ))}
        </div>

        <p className="mt-8 sm:mt-12 text-[11px] uppercase tracking-[0.25em] text-muted2/80">
          Medical Billing Agency
        </p>
      </motion.div>
    </div>
  );
}
